import React from 'react'
import '../../../../components/Business/Common/styles/global.css'
import FirstView from '../../../../components/Business/Foodslabo/FirstView/FirstView'
import SlideShow from '../../../../components/Business/Foodslabo/SlideShow/SlideShow'
import Service from '../../../../components/Business/Foodslabo/Service/Service'
import Charm from '../../../../components/Business/Foodslabo/Charm/Charm'
import Support from '../../../../components/Business/Foodslabo/Support/Support'
import Form from '../../../../components/Business/Foodslabo/Form/Form'
import Footer from '../../../../components/Business/Foodslabo/Footer/Footer'
import Header from '../../../../components/Business/Foodslabo/Header/Header'

export default function FoodslaboContact() {
    return (
        <>
            <Header />
            <FirstView />
            <SlideShow />
            <Service />
            <Charm />
            <Support />
            <Form />
            <Footer />
        </>
    )
}
